import React, { FC } from 'react';

import LegalPage from '~/projects/polyllm-chat/components/LegalPage';
import LegalLoading from '~/projects/polyllm-chat/components/LegalPage/components/LegalLoading';
import { termsOfUseMarkdown } from '~/projects/polyllm-chat/components/LegalPage/config/content';
import { termsOfUseMarkdownUs } from '~/projects/polyllm-chat/components/LegalPage/config/contentUs';
import { legalMarkdownVariables } from '~/projects/polyllm-chat/components/LegalPage/config/variables';
import useLegalMarkdownByCountry from '~/projects/polyllm-chat/components/LegalPage/hooks/useLegalMarkdownByCountry';

const TermsOfUsePage: FC = () => {
  const { markdown, ready } = useLegalMarkdownByCountry({
    default: termsOfUseMarkdown,
    US: termsOfUseMarkdownUs,
  });

  if (!ready) {
    return <LegalLoading />;
  }

  return <LegalPage markdown={markdown} variables={legalMarkdownVariables} />;
};

export default TermsOfUsePage;
